import http from '@/libs/AxiosPlugin'

const data = {
  collectorData (tp, req) {
    if (tp === 1) {
      return http.post('/data/collectorOutputData', req)
    } else {
      return http.post('/data/collectorStatusData', req)
    }
  },

  orderData (req) {
    return http.post('/data/orderData', req)
  },
  orderDayData (req) {
    return http.post('/data/orderDayData', req)
  },
  DailyData () {
    return http.post('/data/DailyData')
  }
}

export default data



// WEBPACK FOOTER //
// ./src/api/data.js